// Campus photo for /colleges/williams-college: Public domain, by Carol M. Highsmith, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHopkins_Hall_at_Williams_College_in_Williamstown%2C_Massachusetts%2C_by_Carol_M._Highsmith%2C_2019%2C_from_the_Library_of_Congress_-_master-pnp-highsm-57900-57945a.tiff), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/williams-college/; credited under the photo.
const photo = {
    "slug": "williams-college",
    "alt": "Hopkins Hall, a red brick building with an arched stone entrance, behind a green lawn at Williams College in Williamstown, Massachusetts",
    "src": "/colleges/williams-college/campus-1600.webp",
    "srcSmall": "/colleges/williams-college/campus-800.webp",
    "srcMid": "/colleges/williams-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/williams-college/og.jpg",
    "title": "Hopkins Hall at Williams College in Williamstown, Massachusetts, by Carol M. Highsmith, 2019, from the Library of Congress - master-pnp-highsm-57900-57945a",
    "author": "Carol M. Highsmith",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHopkins_Hall_at_Williams_College_in_Williamstown%2C_Massachusetts%2C_by_Carol_M._Highsmith%2C_2019%2C_from_the_Library_of_Congress_-_master-pnp-highsm-57900-57945a.tiff",
    "read": "2026-10-01"
};

export default photo;
